module.exports = __webpack_public_path__ + "img/Himbeeren.67490526.svg";